import { BaseMetadata } from '@/common/components/types';

export interface BaseMessage {
  metadata?: BaseMetadata;
}

export const shouldMessageSend = <Message extends BaseMessage>(message: Message) => {
  return message.metadata ? !message.metadata.messageSendingDisabled : true;
};
